import { useEffect } from 'react';
import { useShellLock } from '../contexts/ShellLockContext';

const useShellModalLock = (isOpen) => {
  const { lock, unlock } = useShellLock();

  useEffect(() => {
    if (!isOpen) return;
    lock();
    return () => unlock();
  }, [isOpen, lock, unlock]);
};

export default useShellModalLock;
